import UAParser from 'ua-parser-js';

import DeviceType from '../types/Device';

const getDeviceType = (userAgent?: string): DeviceType => {
	const parser = new UAParser();

	if (!userAgent)
		return {
			isMobile: true,
			isDesktop: false,
			isTablet: false,
			userAgent: '',
			os: '',
		};

	const parserDevice = parser.setUA(userAgent);
	const { type } = parserDevice.getDevice();

	const isMobile = type === 'mobile';
	const isTablet = type === 'tablet';

	return {
		isMobile: !isTablet && isMobile, // only mobile devices
		isDesktop: !isMobile || isTablet, // all devices except mobile
		isTablet,
		userAgent: userAgent,
		os: parser.getOS()?.name,
	};
};

export default getDeviceType;
